<template>
  <div class="token-stat-card">
    <!-- 顶部学校+总消耗 -->
    <div v-if="stat">
      <div class="stat-header">
        <div class="school-info">
          <span class="label">学校</span>
          <span class="school-name">{{ stat.schoolName||'' }}</span>
        </div>
        <div class="total-token">
          <span class="label">总消耗 Token</span>
          <span class="num">{{ stat.allTokenTotal ||0 }}</span>
        </div>
      </div>

      <!-- 顶部4个数据卡片 -->
      <div class="stat-grid">
        <div class="grid-item chat">
          <div class="icon"><img src="@/ico/stutas/test/chatYes.svg" alt="" /></div>
          <div class="info">
            <div class="title">对话消耗</div>
            <div class="num">{{ stat.chatTotal || 0 }}</div>
            <div class="sub">
              输入 {{ stat.chatInput || 0 }} ·输出 {{ stat.chatOutput || 0 }}
            </div>
          </div>
        </div>
        <div class="grid-item work">
          <div class="icon"><img src="@/ico/stutas/work.svg" alt="" /></div>
          <div class="info">
            <div class="title">作品消耗</div>
            <div class="num">{{ stat.workTotal || 0 }}</div>
            <div class="sub">
              输入 {{ stat.workInput || 0 }} · 输出 {{ stat.workOutput || 0 }}
            </div>
          </div>
        </div>
        <div class="grid-item input">
          <div class="icon"><img src="@/ico/analysis.svg" alt="" /></div>
          <div class="info">
            <div class="title">总输入</div>
            <div class="num">{{ stat.totalInput || 0 }}</div>
          </div>
        </div>
        <div class="grid-item output">
          <div class="icon"><img src="@/ico/stutas/report.svg" alt="" /></div>
          <div class="info">
            <div class="title">总输出</div>
            <div class="num">{{ stat.totalOutput || 0 }}</div>
          </div>
        </div>
      </div>

      <!-- 智能体分布明细 -->
      <div class="model-section">
        <div class="section-title">智能体分布明细</div>
        <div class="model-wrap" style="max-height:380px;overflow-y:auto;padding-right:6px;">
          <div class="model-grid">
            <div class="model-card" v-for="item in modelList || []" :key="item.modelId">
              <div class="model-top">
                <div class="model-name">{{ item.modelName }}</div>
                <div class="model-id">ID: {{ item.modelId }}</div>
              </div>
              <div class="model-row">
                <span>对话</span>
                <span class="num chat">{{ item.chatTotal || 0 }}</span>
              </div>
              <div class="model-row">
                <span>作品</span>
                <span class="num work">{{ item.workTotal || 0 }}</span>
              </div>
              <div class="model-row">
                <span>调用次数</span>
                <span class="num call">{{ item.totalCallCount || 0 }}</span>
              </div>
              <div class="model-row total">
                <span>总消耗</span>
                <span class="num total">{{ item.allTokenTotal || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TokenStatCard",
  data() {
    return {
      stat: {},
      isView:false,
	  modelList:[],
	  login:null
    };
  },
  created() {
    this.getTokenInfo();
  },
  methods: {
	  loginOpen(text) {
	  	this.login = this.$loading({
	  		lock: true,
	  		text,
	  		zIndex: 100001,
	  		spinner: 'el-icon-loading',
	  		background: 'rgba(0,0,0,0.7)'
	  	});
	  },
	  noLogin() {
	  	if (this.login) {
	  		this.login.close();
	  		this.login = null;
	  	}
	  },
    async getTokenInfo() {
      const schoolId = localStorage.getItem("orgId");
      if (!schoolId) return;
	  this.loginOpen('数据查询中...')
      try {
        const res = await this.API.get(this.API.fileurl.getschoolTokenSingle, {schoolId});
        this.stat = res.data.data || {};
		if(this.stat&&this.stat.modelList){
			if(this.stat?.modelList?.length>0){
				this.modelList=this.stat.modelList.sort((a,b)=>b.allTokenTotal-a.allTokenTotal)
			}else{
				this.modelList=[]
			}
		}
      } catch (err) {
        console.error("请求失败", err);
      }finally{
		  this.noLogin()
	  }
    },
  },
};
</script>

<style scoped>
.token-stat-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.school-info,.total-token {
  display: flex;flex-direction: column;gap:4px;
}
.label {font-size:12px;color:#909399;}
.school-name {font-size:16px;font-weight:600;color:#303133;}
.total-token .num {font-size:22px;font-weight:bold;color:#1989fa;}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap:16px;
  margin-bottom:22px;
}
.grid-item {
  display: flex;align-items:center;padding:18px;border-radius:12px;background:#f7f8fa;gap:14px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);
}
.grid-item .icon {
  width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:20px;
}
.grid-item .info {flex:1;}
.grid-item .title {font-size:14px;color:#666;margin-bottom:5px;}
.grid-item .num {font-size:20px;font-weight:bold;color:#303133;line-height:1.2;}
.grid-item .sub {font-size:12px;color:#999;margin-top:3px;}

.chat .icon {background: linear-gradient(135deg,#667eea,#764ba2);}
.work .icon {background: linear-gradient(135deg,#f093fb,#f5576c);}
.input .icon {background: linear-gradient(135deg,#4facfe,#00f2fe);}
.output .icon {background: linear-gradient(135deg,#43e97b,#38f9d7);}

.model-section {margin-top:8px;}
.section-title {font-size:17px;font-weight:600;color:#333;margin-bottom:14px;}
.model-grid {
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap:14px;
}
/* 明细卡片美化 */
.model-card {
  background:#ffffff;
  border-radius:12px;
  padding:16px;
  border-left:4px solid #2979ff;
  box-shadow: 0 2px 8px rgba(41,121,255,0.09);
  transition: all 0.2s;
}
/* hover轻微上浮 */
.model-card:hover{
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(41,121,255,0.13);
}
.model-top {
  display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;padding-bottom:6px;border-bottom:1px solid #f2f3f5;
}
.model-name {font-weight:600;font-size:15px;color:#222;}
.model-id {font-size:12px;color:#b0b3b8;}
.model-row {
  display:flex;justify-content:space-between;font-size:14px;color:#555;padding:4px 0;
}
.model-row.total {
  margin-top:6px;padding-top:8px;border-top:1px dashed #e6e8eb;font-weight:600;
}
.num.chat {color:#667eea;font-weight:500;}
.num.work {color:#e53e3e;font-weight:500;}
.num.call {color:#666666;}
.num.total {color:#2979ff;font-weight:bold;font-size:14px;}

.token-stat-card {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 6% 0%, rgba(64, 158, 255, .14), transparent 28%),
    linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  border: 1px solid rgba(126, 154, 186, .16);
  border-radius: 18px;
  padding: 22px 24px;
  box-shadow: 0 18px 44px rgba(31, 65, 105, 0.09);
}

.stat-header {
  gap: 18px;
  margin-bottom: 22px;
  padding: 20px;
  border-radius: 18px;
  background:
    radial-gradient(circle at 88% 12%, rgba(255, 255, 255, .9), transparent 28%),
    linear-gradient(135deg, #eef7ff 0%, #ffffff 52%, #eefaf5 100%);
  border: 1px solid rgba(126, 154, 186, .14);
}

.label {
  font-size: 12px;
  color: #667085;
  font-weight: 700;
}

.school-name {
  font-size: 22px;
  font-weight: 900;
  color: #172033;
  line-height: 1.25;
}

.total-token {
  align-items: flex-end;
}

.total-token .num {
  font-size: 32px;
  font-weight: 900;
  color: #1989fa;
  line-height: 1;
}

.stat-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-item {
  position: relative;
  overflow: hidden;
  padding: 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, .86);
  border: 1px solid rgba(126, 154, 186, .14);
  box-shadow: 0 12px 28px rgba(31, 65, 105, .07);
  transition: transform .18s ease, box-shadow .18s ease;
}

.grid-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 38px rgba(31, 65, 105, .12);
}

.grid-item .icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  box-shadow: 0 10px 20px rgba(31, 65, 105, .12);
}

.grid-item .icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.grid-item .title {
  font-size: 13px;
  color: #667085;
  font-weight: 700;
}

.grid-item .num {
  font-size: 22px;
  font-weight: 900;
  color: #172033;
}

.grid-item .sub {
  color: #8a94a6;
}

.section-title {
  font-size: 18px;
  font-weight: 900;
  color: #172033;
}

.model-grid {
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
}

.model-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f9fbff 100%);
  border-radius: 16px;
  border: 1px solid rgba(126, 154, 186, .14);
  border-left: none;
  box-shadow: 0 12px 28px rgba(31, 65, 105, .07);
}

.model-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #2f80ed, #42b4f5);
}

.model-card:hover {
  box-shadow: 0 18px 38px rgba(31, 65, 105, .12);
}

.model-name {
  font-weight: 800;
  color: #172033;
}

@media (max-width: 1100px) {
  .stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .token-stat-card {
    padding: 14px;
    border-radius: 14px;
  }

  .stat-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 16px;
  }

  .total-token {
    align-items: flex-start;
  }

  .stat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
